import styled from "styled-components";
const Wrapper = styled.div`
    width: 100%;
    min-height: 142px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    background-color: #144344;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-position-y: 62px;
    background-position-x: 89%;
    background-size: 85px 85px;
  
    & img {
        width: 44px;
        margin-top: 20px;
    }
    
    .text-container {
        display: flex;
        flex-direction: row;
        align-items: start;
        gap: 10px;
        margin-top: 10px;
    }
  
    .text {
        color: #fff;
        font-size: 19px;
        font-weight: 700;
        margin-top: 10px;
    } 
  
    & span {
      color: #FECE2F;
    }
`;

const ButtonContainer = styled.div`
    display: block;
    width: 80px;
    height: 40px;
    position: relative;
`;

export default function DxfHeaderContainer({mode, configStarted}) {
    return (
        <Wrapper className={mode && configStarted ? 'hidden' : ''}>
            <div className="text-container">
                <img src={"/wp-content/uploads/2023/09/icon-upload.png"}  alt="Télécharger votre fichier DXF"/>
                <p className="text">Importez votre <span>fichier DXF</span> et nous nous occupons de la découpe !</p>
                <ButtonContainer>
                    <button className="lity-close hjt" type="button" aria-label="Close (Press escape to close)"
                            data-lity-close="">×
                    </button>
                </ButtonContainer>
            </div>
        </Wrapper>
    );
};